import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

/** SPI menu icon — a compact analytics / bar-chart mark. */
const IconSpi: React.FC<IconProps> = ({
  size = 19,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path
      d="M2.5 16.5h14"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <rect x="3.5" y="9" width="2.6" height="5" rx="0.6" stroke="currentColor" strokeWidth="1.2" />
    <rect x="8.2" y="5.5" width="2.6" height="8.5" rx="0.6" stroke="currentColor" strokeWidth="1.2" />
    <rect x="12.9" y="11" width="2.6" height="3" rx="0.6" stroke="currentColor" strokeWidth="1.2" />
    <path
      d="M3.5 6.5 7 4l3 1.5L15.5 2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconSpi;
